<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
          <h1>{{ $t('Client') }} List</h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-results-details">
        <div class="row">
          <div class="col-xs-12 col-sm-4">
            <router-link :to="{ name: 'clients.create' }" class="btn btn-sm btn btn-primary"><i class="fa fa-plus"></i> Add Client</router-link>
          </div>
        </div>
      </div>

      <user-list-filters
        class="margin-y-1"
        :set-filter-mutation="setFilter"
        :filters="filters"
        :apply-filters="handleApplyFiltersCallback"
        :show-region-filter="$userIsGlobalAdmin">
        <ladda-button
          slot="button"
          :click="handleApplyFiltersCallback"
          type="submit"
          class="btn btn-primary pull-right">
          Search
        </ladda-button>
      </user-list-filters>

      <div class="dashboard-block">
        <ul class="nav nav-tabs" id="myTabs" role="tablist">
          <li :class="classForStatus('all')">
            <router-link :to="{ params: { status: 'all' }, query: $route.query }">All ({{ clientsCounts.all || 0 }})</router-link>
          </li>
          <li :class="classForStatus('active')">
            <router-link :to="{ params: { status: 'active' }, query: $route.query }">Active ({{ clientsCounts.active || 0 }})</router-link>
          </li>
          <li :class="classForStatus('unverified')">
            <router-link :to="{ params: { status: 'unverified' }, query: $route.query }">Unverified ({{ clientsCounts.unverified || 0 }})</router-link>
          </li>
          <li :class="classForStatus('trash')">
            <router-link :to="{ params: { status: 'trash' }, query: $route.query }"><i class="fa fa-trash"></i></router-link>
          </li>
          <li class="ml-auto text-right" v-if="$route.params.status==='unverified' && (!filters.keywords)">
            <ladda-button
              slot="button"
              :click="handleSendActivationEmail"
              type="submit"
              class="btn btn-primary">
              Send Activation Email
            </ladda-button>
            <span class="help-block">This will notify all users who have not responded within the 24 hour period.</span>
          </li>
        </ul>

        <pickstar-loading v-if="fetchingClients" class="m-t-lg"/>

        <no-results v-else-if="haveNoClients">
          There are no clients.
        </no-results>

        <ul class="item-detail item-detail-profile" v-else>
          <client-list-item
            v-for="client in clients"
            :key="client.id"
            :client="client"/>
        </ul>

        <lazy-loading
          class="text-center"
          :loading="loading"
          :reached-bottom="handleGetNextClientsCallback"
          ref="lazyLoading">
          <pickstar-loading slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { appliesFilters, handleServerErrors } from 'mixins'
import LazyLoading from 'codium-lazy-loading'
import ClientListItem from './ClientListItem'
import UserListFilters from '../UserListFilters'
import { notify } from 'utils'

export default {
  mixins: [appliesFilters, handleServerErrors],

  props: {
    status: {
      required: false,
      default: 'all'
    }
  },

  computed: {
    ...mapState('client', ['clients', 'clientsCounts', 'pagination']),
    ...mapState('user', ['filters']),
    ...mapState('app', ['loading']),

    haveNoClients () {
      return this.clients.length === 0
    }
  },

  components: {
    UserListFilters,
    ClientListItem,
    LazyLoading
  },

  watch: {
    '$route' () {
      this.resetClients()

      this.fetchingClients = true

      this.getClientsCounts(this.queryParams)
        .catch(this.handleServerErrorsCallback)

      this.getClients(this.queryParams)
        .then(() => {
          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingClients = false
        })
    }
  },

  data () {
    return {
      searchName: null,
      fetchingClients: false
    }
  },

  created () {
    this.searchName = this.$route.query.name || null

    this.getClients(this.queryParams)
      .catch(this.handleServerErrorsCallback)

    this.getClientsCounts(this.queryParams)
      .catch(this.handleServerErrorsCallback)
  },

  methods: {
    ...mapActions('client', ['getClients', 'getNextClients', 'getClientsCounts', 'resetClients']),
    ...mapActions('user', ['setFilter', 'resetFilters', 'sendActivationEmail']),

    handleGetNextClientsCallback () {
      return this.getNextClients(this.queryParams)
    },

    classForStatus (status) {
      if (this.status === status) {
        return 'active'
      }

      return ''
    },

    handleSendActivationEmail () {
      return this.sendActivationEmail('client').then((response) => {
        notify.success('Email Activation sent to all ‘Unverified users’.')
      }).catch((error) => {
        notify.error('Error occurred.')
        return Promise.reject(error)
      })
    }
  }
}
</script>
